var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 12.7925L13.5507 11.2419C13.7595 11.0356 14.0236 10.8944 14.3111 10.8355C14.5985 10.7765 14.8968 10.8022 15.1699 10.9096L17.0589 11.6641C17.3349 11.7762 17.5715 11.9675 17.739 12.2138C17.9065 12.4602 17.9973 12.7507 18 13.0486V16.5098C17.9984 16.7124 17.9558 16.9127 17.8748 17.0985C17.7938 17.2842 17.6761 17.4517 17.5287 17.5907C17.3813 17.7298 17.2073 17.8376 17.0171 17.9076C16.827 17.9776 16.6247 18.0083 16.4223 17.9981C3.18528 17.1743 0.514341 5.96015 0.00921507 1.66831C-0.0142332 1.45755 0.00719085 1.24421 0.0720778 1.04233C0.136965 0.840448 0.243844 0.654598 0.385684 0.497007C0.527524 0.339416 0.701111 0.213655 0.895024 0.127997C1.08894 0.0423395 1.29878 -0.00127313 1.51075 2.82909e-05H4.85289C5.15113 0.000911431 5.44228 0.0910343 5.6889 0.258805C5.93553 0.426576 6.12634 0.664322 6.23679 0.941464L6.99102 2.83126C7.10191 3.10335 7.1302 3.4021 7.07236 3.69019C7.01452 3.97827 6.87312 4.24292 6.66581 4.45108L5.11583 6.00168C5.11583 6.00168 6.00845 12.0449 12.0008 12.7925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.373b1ff4ee949df03c69da46796c1ac1.svg";
export { ForwardRef as ReactComponent };